export const cleanImage = image => {
  if (!image) return image;
  return [
    'https://cdn.farmakom.io',
    'https://api.farmakom.io',
    'https://api.farmakom.it',
    'https://api2.farmakom.it',
  ].reduce((acc, url) => acc.replace(url, ''), image);
};
